import {
  useAuthStore,
  isAdmin,
  isDoctor,
  isReceptionist,
  hasRole as hasRoleHelper
} from '@/stores/auth.store';
import { UserRole } from '@/types/models';

export function useAuth() {
  const authState = useAuthStore();
  const {
    user,
    isAuthenticated,
    isLoading,
    isInitialized,
    mustChangePassword,
    login,
    logout,
    changePassword,
  } = authState;

  return {
    user,
    isLoading,
    isInitialized,
    isAuthenticated,
    isAdmin: isAdmin(authState),
    isDoctor: isDoctor(authState),
    isReceptionist: isReceptionist(authState),
    mustChangePassword,
    hasRole: (role: UserRole) => hasRoleHelper(authState, role),
    login,
    logout,
    changePassword,
  };
}
